import type { Command } from '@o2d/history';
import type { BoardState } from '../state/board-state.js';
import type { BoardObject } from '../interfaces/board-object.interface.js';

/** Add a fully-formed object to the board. Revert removes it by id. */
export class AddObjectCommand implements Command<BoardState> {
  readonly label = 'Objekt hinzufügen';
  constructor(private readonly _object: BoardObject) {}

  get object(): BoardObject {
    return this._object;
  }

  apply(state: BoardState): void {
    state.addObject(this._object);
  }

  revert(state: BoardState): void {
    state.removeObject(this._object.id);
  }
}
